import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const deleteScopedSchedules = api(async function deleteScopedSchedules({ projectId, scheduleIds }) {
    if (!projectId || !scheduleIds?.length) return null

    return mutate(
        gql`
            mutation DeleteScopedSchedules($projectId: String!, $scheduleIds: [String!]!) {
                deleteScopedSchedules(projectId: $projectId, scheduleIds: $scheduleIds)
            }
        `,
        { projectId, scheduleIds },
        { returns: "deleteScopedSchedules" }
    )
})
